import type { ConversationType, ItemRow } from 'owa-graph-schema';

/**
 * Filters item rows to only include items received today or the previous day
 * @param rows - Array of ItemRow to filter
 * @returns Filtered array containing only items from today and yesterday
 */
export function filterItemRowsForPriorityView(rows: ItemRow[]): ItemRow[] {
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    // Calculate start of yesterday (24 hours before start of today)
    const startOfYesterday = new Date(startOfToday);
    startOfYesterday.setDate(startOfYesterday.getDate() - 1);

    return rows.filter(row => {
        if (!row.DateTimeReceived) {
            return false;
        }

        const receivedDate = new Date(row.DateTimeReceived);

        // Include if received on or after start of yesterday
        return receivedDate >= startOfYesterday;
    });
}

/**
 * Filters conversation rows to only include conversations with last delivery today or the previous day
 * @param rows - Array of ConversationType to filter
 * @returns Filtered array containing only conversations from today and yesterday
 */
export function filterConversationRowsForPriorityView(
    rows: ConversationType[]
): ConversationType[] {
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    // Calculate start of yesterday (24 hours before start of today)
    const startOfYesterday = new Date(startOfToday);
    startOfYesterday.setDate(startOfYesterday.getDate() - 1);

    return rows.filter(row => {
        if (!row.LastDeliveryTime) {
            return false;
        }

        const lastDeliveryDate = new Date(row.LastDeliveryTime);

        // Include if last delivery on or after start of yesterday
        return lastDeliveryDate >= startOfYesterday;
    });
}
